<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Основной участок</div>
            <div class="dx-field-value">
                <ai-select-box-clearable :value="data?.code" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiSelectBoxClearable from '@/components/ai-select-box-clearable.vue';

const data = inject('data');
</script>
